import React, { useEffect, useRef } from "react"
import { RankingData } from "../types"
import ShareCard from "./ShareCard"
import "./ShareModal.css"

interface ShareModalProps {
  isOpen: boolean
  onClose: () => void
  data: RankingData
  topEFPower: number
  avatar: string
  defaultAvatar: string
}

const ShareModal: React.FC<ShareModalProps> = ({
  isOpen,
  onClose,
  data,
  topEFPower,
  avatar,
  defaultAvatar,
}) => {
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isOpen) return

    const previousActiveElement = document.activeElement as HTMLElement

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose()
      }
    }

    window.addEventListener("keydown", handleEscape)

    if (modalRef.current) {
      modalRef.current.focus()
    }

    document.body.style.overflow = "hidden"

    return () => {
      window.removeEventListener("keydown", handleEscape)
      document.body.style.overflow = ""
      previousActiveElement?.focus()
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 modal-overlay p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div
        ref={modalRef}
        className="relative bg-black/70 backdrop-blur-xl rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] flex flex-col modal-content outline-none"
        onClick={(e) => e.stopPropagation()}
        tabIndex={-1}
      >
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 modal-close-button"
          aria-label="Close modal"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        <ShareCard
          data={data}
          topEFPower={topEFPower}
          avatar={avatar}
          defaultAvatar={defaultAvatar}
        />
      </div>
    </div>
  )
}

export default ShareModal
